export const nameofFactory = <T>() => (name: keyof T) => name

export const getExtension = (url: string) => url.split('.').pop()
